import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.25C6.615 2.25 2.25 6.615 2.25 12C2.25 17.385 6.615 21.75 12 21.75C17.385 21.75 21.75 17.385 21.75 12C21.75 6.615 17.385 2.25 12 2.25ZM7.72 11.47C7.57955 11.6106 7.50066 11.8012 7.50066 12C7.50066 12.1988 7.57955 12.3894 7.72 12.53L10.72 15.53C10.7887 15.6037 10.8715 15.6628 10.9635 15.7038C11.0555 15.7448 11.1548 15.7668 11.2555 15.7686C11.3562 15.7704 11.4562 15.7518 11.5496 15.7141C11.643 15.6764 11.7278 15.6203 11.799 15.549C11.8703 15.4778 11.9264 15.393 11.9641 15.2996C12.0018 15.2062 12.0204 15.1062 12.0186 15.0055C12.0168 14.9048 11.9948 14.8055 11.9538 14.7135C11.9128 14.6215 11.8537 14.5387 11.78 14.47L10.06 12.75H15.75C15.9489 12.75 16.1397 12.671 16.2803 12.5303C16.421 12.3897 16.5 12.1989 16.5 12C16.5 11.8011 16.421 11.6103 16.2803 11.4697C16.1397 11.329 15.9489 11.25 15.75 11.25H10.06L11.78 9.53C11.9125 9.38782 11.9846 9.19978 11.9812 9.00548C11.9777 8.81118 11.899 8.62579 11.7616 8.48838C11.6242 8.35097 11.4388 8.27225 11.2445 8.26882C11.0502 8.2654 10.8622 8.33752 10.72 8.47L7.72 11.47Z"
        fill={colorValue}
      />
    </svg>
  );
};
